import { render, staticRenderFns } from "./RealisationStep3B.vue?vue&type=template&id=0ffbce69"
import script from "./RealisationStep3B.vue?vue&type=script&lang=js"
export * from "./RealisationStep3B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports